<span class="flex flex-row items-center">
  <input
    type="text"
    [value]="value"
    [readonly]="isUserSelected"
    matInput
    (input)="searchCustomers($event)"
    [matAutocomplete]="userAutocomplete"
    [matAutocompleteConnectedTo]="{
      elementRef: input
    }"
  />
  @if (loading) {
  <mat-spinner class="fixed" diameter="12" matSuffix></mat-spinner>
  } @if (isUserSelected && !loading) {
  <button
    matSuffix
    size="sm"
    ctx-button--secondary
    type="button"
    color="accent"
    actionIcon="CLEAR"
    (click)="clearUser()"
  ></button>
  }
</span>
<mat-autocomplete
  #userAutocomplete="matAutocomplete"
  autoSelectActiveOption
  [displayWith]="displayUser"
  (optionSelected)="handleUserSelection($event)"
>
  @for (user of searchedCustomers; track user) {
  <mat-option class="ph-no-capture" [value]="user.id">
    {{ user.name + ' (' + user.email + ')' }}
  </mat-option>
  }
</mat-autocomplete>
